import { PromoCodeStatus } from 'api/promoCodes/enums'
import { couponValues } from 'api/promoCodes/types'

export const STATUS_LABELS: Record<PromoCodeStatus, string> = {
  [PromoCodeStatus.ACTIVE]: 'Active',
  [PromoCodeStatus.CANCELED]: 'Canceled',
  [PromoCodeStatus.EXPIRED]: 'Expired',
  [PromoCodeStatus.DISABLED]: 'Canceled',
}

export const getPromoCodeLabel = (status: PromoCodeStatus): string => {
  return STATUS_LABELS[status] || 'Unknown'
}

export const DISCOUNT_TYPE_LABELS: Record<string, string> = {
  [couponValues.PERCENTAGE_OFF.value]: couponValues.PERCENTAGE_OFF.label,
  [couponValues.FIXED_DISCOUNT.value]: couponValues.FIXED_DISCOUNT.label,
}

export const getDiscountTypeLabel = (type: string): string => DISCOUNT_TYPE_LABELS[type] || type

export const formatPromoDescription = (
  discountAmount: number | null,
  discountType: string
): string => {
  if (!discountAmount) return ''

  const isPercentage = discountType === couponValues.PERCENTAGE_OFF.value

  const formattedAmount = isPercentage
    ? `${discountAmount}%`
    : `$${discountAmount}`

  return `${formattedAmount} off Entire Order`
}